import { Component, EventEmitter, Input, Output } from '@angular/core';
import { number } from 'echarts';
import { BaseComponent } from 'src/app/core/components/base-component.class';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent extends BaseComponent{
  @Input() innerWidth: number = 0;
  @Output() menuClick = new EventEmitter<boolean>(true);
  @Input() showMenuText:boolean = true;

  currentYear!: number;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

}
